import React, { useState, useRef, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./PPQuizTaker.css";
import { Modal } from "react-bootstrap";
import ModalDialog from "react-bootstrap/ModalDialog";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import { useStopwatch } from "react-timer-hook";
import { useBeforeunload } from "react-beforeunload";
import InnerHTML from "dangerously-set-html-content";
import { get, put } from "../../../../app/shared/http";
import { handleException } from "../../../../app/util/util";
import {
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../../app/util/HOC";

const SUBMIT_QUIZ_DIALOG_TITLE_ID = "submit-quiz-dialog-title";
const SUBMIT_QUIZ_DIALOG_DESCRIPTION_ID = "submit-quiz-dialog-description";

const PracticePerfectModalDialog = React.forwardRef(
  ({ dialogLabelledBy, ...props }, ref) => (
    <ModalDialog
      {...props}
      ref={ref}
      role="dialog"
      aria-modal="true"
      aria-labelledby={dialogLabelledBy}
    />
  ),
);

PracticePerfectModalDialog.displayName = "PracticePerfectModalDialog";

export default function PPQuizTaker(props) {
  let ppQuizResultVO = props.ppQuizResultVO,
    videoPPQuiz = props.videoPPQuiz;
  const history = useHistory();
  const tollTipTarget = useRef(null);
  const ppQuizResetPopupFocus = useRef(null);
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const { isbn, subtopictagid, subjectareatagid } = useParams();
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const ppIsbn =
    isbn && isbn !== "undefined" ? isbn : localStorage.getItem("bookIsbn");
  const authToken = userVO.apJwtAuthenticationToken
    ? userVO.apJwtAuthenticationToken
    : localStorage.getItem("apJwtAuthenticationToken");
  const quizTime = videoPPQuiz.quiz_time && videoPPQuiz.quiz_time * 60;
  const { seconds, minutes, hours, pause, start } = useStopwatch({
    autoStart: true,
  });
  const totalQuests = videoPPQuiz.questions.length
    ? videoPPQuiz.questions[0].length
    : 0;
  const totalQuizTime = videoPPQuiz.totalTimeSpent,
    quizQuesAns = [],
    quizQuests = videoPPQuiz.questions.length ? videoPPQuiz.questions[0] : [];
  const [showToolTip, setShowToolTip] = useState(false);
  const [showAnswerFlag, setShowAnswerFlag] = useState(false);
  const [submitQuizPopUp, setSubmitQuizPopUp] = useState(false);
  const [showQuestionList, setShowQuestionList] = useState(false);
  const [isResetNotificationData, setResetNotificationData] = useState();
  const [isShowStdQuizResetPopup, setShowStdQuizResetPopup] = useState(false);
  const [totalAnsQuests, setTotalAnsQuests] = useState(
    videoPPQuiz.totalAnswered,
  );
  const [totalUnAnsQuests, setTotalUnAnsQuests] = useState(
    totalQuests - videoPPQuiz.totalAnswered,
  );
  const submitQuizDialogTitle =
    totalUnAnsQuests === 0
      ? "Submit quiz confirmation"
      : "Unanswered questions";
  const [currQuest, setCurrQuest] = useState(
    videoPPQuiz.currentQuestion === 0
      ? videoPPQuiz.currentQuestion + 1
      : videoPPQuiz.currentQuestion,
  );
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  useEffect(() => {
    if (ppQuizResetPopupFocus.current !== null) {
      ppQuizResetPopupFocus.current.focus();
    }
  }, [isShowStdQuizResetPopup]);
  useEffect(() => {
    if (isResetNotificationData != undefined) {
      updatePPRestNotification();
    }
  }, [isResetNotificationData]);
  function fetchSaveForLater() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      quizDetails: {
        currentQuestion: currQuest,
        type: ppQuizResultVO.quizType,
        totalAnswered: totalAnsQuests,
        questionIdentifiers: quizQuesAns,
        isGraded: ppQuizResultVO.isGraded,
        instanceId: ppQuizResultVO.instanceId,
        identifier: videoPPQuiz.quiz_identifier,
        totalTimeSpent: totalQuizTime + convertHMSToSeconds(),
      },
    };
    let requestOptions = {
      method: "POST",
      keepalive: true,
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/PP/ppQuizSaveForLater`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchSubmitQuiz() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      quizDetails: {
        totalAnswered: totalAnsQuests,
        numberOfQuestions: totalQuests,
        questionIdentifiers: quizQuesAns,
        isGraded: ppQuizResultVO.isGraded,
        productType: ppQuizResultVO.quizType,
        identifier: videoPPQuiz.quiz_identifier,
        instanceId: Number(ppQuizResultVO.instanceId),
        totalTimeSpent: totalQuizTime + convertHMSToSeconds(),
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(`${localStorage.getItem("qpAPI")}/PP/Submit-Quiz`, requestOptions)
      .then(handleResponse)
      .then((response) => response.text())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data === "Successfully Inserted Quiz Results") {
          history.push(
            `/pp-quiz/results/${isbn}/${subtopictagid}/${subjectareatagid}/${ppQuizResultVO.instanceId}`,
          );
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  useBeforeunload(() => {
    handleSaveForLater();
  });
  function convertSecondsToHMS(value) {
    const sec = parseInt(value, 10);
    let hrs = Math.floor(sec / 3600);
    let mins = Math.floor((sec - hrs * 3600) / 60);
    let secs = sec - hrs * 3600 - mins * 60;
    if (mins < 10) {
      mins = "0" + mins;
    }
    if (secs < 10) {
      secs = "0" + secs;
    }
    return hrs + "h " + mins + "m " + secs + "s";
  }
  function convertHMSToSeconds() {
    return hours * 3600 + minutes * 60 + seconds;
  }
  function handleSelOption() {
    var count = 0;
    quizQuests.map((ques) => {
      if (ques.SelectedAnswer.length !== 0) {
        count += 1;
      }
    });
    setTotalAnsQuests(count);
    setTotalUnAnsQuests(totalQuests - count);
  }
  function handleNextUnAnsw() {
    for (var i = 0; i < quizQuests.length; i++) {
      if (quizQuests[i].SelectedAnswer.length === 0) {
        setCurrQuest(quizQuests[i].questionOrder);
        break;
      }
    }
  }
  function handleSaveResponses() {
    let eachQuesTime = 0,
      currQuesNo = 0,
      quesIndex = currQuest - 1;
    if (quizQuesAns.length === 0) {
      quizQuests.map((ques) => {
        if (quesIndex === currQuest - 1) {
          while (currQuesNo < totalQuests) {
            eachQuesTime += quizQuests[currQuesNo].timeSpent;
            currQuesNo += 1;
          }
          quizQuests[quesIndex].timeSpent += Math.abs(
            totalQuizTime + convertHMSToSeconds() - eachQuesTime,
          );
        }
        quesIndex += 1;
        var newSetQuizQues = {
          SelectedAnswer: ques.SelectedAnswer,
          identifier: ques.identifier,
          timeSpent: ques.timeSpent,
          subTopicTagId: ques.subTopicTagId,
        };
        quizQuesAns.push(newSetQuizQues);
      });
    }
  }
  function handleSaveForLater() {
    handleSaveResponses();
    fetchSaveForLater();
  }
  function handleNavigateBack(backType) {
    handleSaveForLater();
    if (backType === "video" || backType === "Video") {
      history.push(`/pp-video-library/${isbn}/video/${subtopictagid}`);
    } else {
      history.push(`/pp-quiz-center/${isbn}`);
    }
  }
  function handleSubmitQuiz() {
    setSubmitQuizPopUp(false);
    handleSaveResponses();
    fetchSubmitQuiz();
  }
  function handlePrevNxtBtn() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setShowAnswerFlag(false);
    handleSaveForLater();
  }
  const getPPRestNotification = () => {
    get(
      "/admin/RestNotification?key=pp&user_Id=" +
        userVO.userId +
        "&instance_id:" +
        ppQuizResultVO.instanceId,
      "qpAPI",
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else {
          if (data.status == true) {
            setShowStdQuizResetPopup(true);
            setResetNotificationData(data.NotificationList);
          } else {
            pause();
            setSubmitQuizPopUp(true);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const updatePPRestNotification = (notifyValue) => {
    let collectionOfRNjson = [];
    isResetNotificationData &&
      isResetNotificationData.forEach((notificationVal) => {
        let RNjson = {
          userId: userVO.userId,
          key_name: notificationVal.key_name,
          notificationId: notificationVal.NotificationId,
          value: notifyValue === 3 ? 3 : parseInt(notificationVal.value) + 1,
        };
        collectionOfRNjson.push(RNjson);
      });
    let reqData = {
      notificationList: collectionOfRNjson,
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: userVO.keepMeLoggedInFlag,
      },
    };
    put("/admin/updateRestNotification", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleRedirectHome = () => {
    history.push(`/pp-video-library/${ppIsbn}`);
  };
  return (
    <div className="container">
      <div className="card">
        <div className="card-body ppQuizContainerCard">
          <div className="row">
            <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="ppQuizLogoContainer">
                <p>
                  <span className="ppQuizCommonStyle ppQuizLogoBoldText">
                    PracticePerfect<sup>TM</sup>
                  </span>
                  <span className="ppQuizCommonStyle ppQuizLogoText">
                    {localStorage.getItem("ppProductName") !== undefined &&
                      localStorage.getItem("ppProductName")}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-8 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="mt-3">
                <p className="ppQuizCommonStyle ppQuizTitle mb-2">
                  {ppQuizResultVO.quizType === "video" ||
                  ppQuizResultVO.quizType === "Video"
                    ? ppQuizResultVO.customerFacingSubTopicName
                    : (ppQuizResultVO.quizType.toLowerCase() ===
                        "summative a" ||
                      ppQuizResultVO.quizType.toLowerCase() === "comparative1"
                        ? `Comparative Quiz A: Quiz `
                        : ppQuizResultVO.quizType.toLowerCase() ===
                              "summative b" ||
                            ppQuizResultVO.quizType.toLowerCase() ===
                              "comparative2"
                          ? `Comparative Quiz B: Quiz `
                          : ppQuizResultVO.quizType.toLowerCase() ===
                              "comparative3"
                            ? `Comparative Quiz C: Quiz `
                            : ppQuizResultVO.quizType.toLowerCase() ===
                                "comparative4"
                              ? `Comparative Quiz D: Quiz `
                              : ppQuizResultVO.quizType.toLowerCase() ===
                                    "cumulative" ||
                                  ppQuizResultVO.quizType.toLowerCase() ===
                                    "cumulative2"
                                ? `Comparative Quiz: All Topics: Quiz `
                                : ppQuizResultVO.quizType + ": Quiz ") +
                      ppQuizResultVO.quizAttempt}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-8 col-lg-6 col-md-6 col-sm-12 col-12">
              <button
                className="mt-3 ppQuizBackBtn"
                onClick={() => handleNavigateBack(ppQuizResultVO.quizType)}
              >
                {ppQuizResultVO.quizType === "video" ||
                ppQuizResultVO.quizType === "Video"
                  ? `Back to Video`
                  : `Back to Quiz Center`}
              </button>
            </div>
          </div>
          {quizQuests.length ? (
            <>
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-3 col-md-3 col-sm-7 col-7 no-padding">
                    <button
                      type="button"
                      className="mt-2 ppQuizShowList"
                      aria-expanded={showQuestionList}
                      aria-controls="ppQuizQuestionListPanel"
                      onClick={() => setShowQuestionList(!showQuestionList)}
                    >
                      {showQuestionList
                        ? "Hide Question List"
                        : "Show Question List"}
                    </button>
                    {showQuestionList ? (
                      <div
                        id="ppQuizQuestionListPanel"
                        className="ppQuizQuestions pl-3 mr-4"
                        role="region"
                        aria-label="Question list"
                      >
                        {totalUnAnsQuests === 0 ? (
                          <div className="py-3"></div>
                        ) : (
                          <button
                            type="button"
                            className="ppQuizNext py-3"
                            onClick={handleNextUnAnsw}
                          >
                            Next Unanswered
                          </button>
                        )}

                        <ul className="list-unstyled m-0 p-0">
                          {quizQuests.map((ques) => {
                            const isCurrent = ques.questionOrder === currQuest;
                            const isAnswered = ques.SelectedAnswer.length !== 0;

                            return (
                              <li key={ques.identifier || ques.questionOrder}>
                                <button
                                  type="button"
                                  className={
                                    isAnswered
                                      ? "ppQuizQuestion pb-2"
                                      : "ppQuizQuestionUn pb-2"
                                  }
                                  style={
                                    isCurrent ? { background: "#DADADA" } : null
                                  }
                                  aria-current={isCurrent ? "true" : undefined}
                                  aria-label={`Question ${ques.questionOrder}, ${
                                    isAnswered ? "Answered" : "Unanswered"
                                  }${isCurrent ? ", current question" : ""}`}
                                  onClick={() => {
                                    setCurrQuest(ques.questionOrder);
                                    setShowAnswerFlag(false);
                                    window.scrollTo({
                                      top: 0,
                                      left: 0,
                                      behavior: "smooth",
                                    });
                                  }}
                                >
                                  {ques.questionOrder}:{" "}
                                  {isAnswered ? "Answered" : "Unanswered"}
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                  <div
                    className={
                      showQuestionList
                        ? "col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 no-padding ppQuizQuestionsExpandStyle"
                        : "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding ppQuizQuestionsCollapseStyle"
                    }
                  >
                    <div className="row">
                      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 pb-2">
                        <span className="ppQuizQuestionStatus">Question:</span>
                        <br></br>
                        <span className="ppQuizQuestionDetail">
                          {currQuest} of {totalQuests}
                        </span>
                      </div>
                      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 pr-0">
                        <span className="ppQuizQuestionStatus">
                          Unanswered:
                        </span>
                        <br></br>
                        <span className="ppQuizQuestionDetail">
                          {totalUnAnsQuests} of {totalQuests}
                        </span>
                      </div>
                      <div className="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-6 pl-md-2">
                        {ppQuizResultVO.isGraded === false ||
                        ppQuizResultVO.isGraded === "false" ? null : (
                          <>
                            <span className="ppQuizQuestionStatus">
                              Time Spent:
                            </span>
                            <br></br>
                            {quizTime &&
                            convertHMSToSeconds() + totalQuizTime > quizTime ? (
                              <>
                                <span className="ppQuizQuestionDetailTimeExc">
                                  {convertSecondsToHMS(
                                    convertHMSToSeconds() + totalQuizTime,
                                  )}
                                </span>
                                <div
                                  data-testid="time_exceeded_tooltip"
                                  className="fa fa-exclamation-circle ppQuizQuestionDetailTimeExcl"
                                  ref={tollTipTarget}
                                  onClick={() => setShowToolTip(!showToolTip)}
                                ></div>
                                <Overlay
                                  placement="bottom"
                                  target={tollTipTarget.current}
                                  show={showToolTip}
                                  onHide={() => setShowToolTip(false)}
                                  rootClose
                                >
                                  <Tooltip
                                    id="ppQuizQuestionDetailOverlay"
                                    className="ppQuizQuestionDetailToolTip"
                                  >
                                    You've exceeded the time limit you set, but
                                    you can continue taking this quiz.
                                  </Tooltip>
                                </Overlay>
                              </>
                            ) : (
                              <span className="ppQuizQuestionDetail">
                                {convertSecondsToHMS(
                                  convertHMSToSeconds() + totalQuizTime,
                                )}
                              </span>
                            )}
                          </>
                        )}
                      </div>
                      <div className="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 p-0">
                        {/* <button className="btn ppQuizSubmitBtn ml-xl-3 ml-lg-3 ml-md-2 ml-3 rounded-0"
                                                        onClick={() => [pause(), setSubmitQuizPopUp(true)]}>Submit Quiz</button> */}
                        <button
                          className="btn ppQuizSubmitBtn ml-xl-3 ml-lg-3 ml-md-2 ml-3 rounded-0"
                          onClick={() => getPPRestNotification()}
                        >
                          Submit Quiz
                        </button>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      {quizQuests.map((ques) => {
                        return ques.questionOrder === currQuest ? (
                          <>
                            //Question Text
                            <div
                              id={ques.question_identifier}
                              className="ppQuizQuestionDesc col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            >
                              <InnerHTML html={ques.promptText} />
                            </div>
                            //Answers
                            <div className="mt-4 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              {ques.choiceInteraction.simpleChoices.map(
                                (opt, optIndex) => {
                                  return (
                                    <>
                                      <div
                                        key={optIndex}
                                        className="d-flex d-flex-row"
                                      >
                                        <span style={{ marginRight: "3px" }}>
                                          {showAnswerFlag == true ? (
                                            ques.SelectedAnswer === "" ? (
                                              opt.correct ? (
                                                <i className="fas fa-check-circle ppQuizOptCrtCir"></i>
                                              ) : (
                                                <i
                                                  className="fas fa-check-circle ppQuizOptCrtCir"
                                                  style={{ color: "#fff" }}
                                                ></i>
                                              )
                                            ) : ques.SelectedAnswer ===
                                              opt.identifier ? (
                                              opt.correct ? (
                                                <i className="fas fa-check-circle ppQuizOptCrtCir"></i>
                                              ) : (
                                                <i className="fas fa-times-circle ppQuizOptWrnCir"></i>
                                              )
                                            ) : opt.correct ? (
                                              <i className="fas fa-check-circle ppQuizOptCrtCir"></i>
                                            ) : (
                                              <i
                                                className="fas fa-check-circle ppQuizOptCrtCir"
                                                style={{ color: "#fff" }}
                                              ></i>
                                            )
                                          ) : null}
                                        </span>
                                        <div>
                                          <input
                                            data-testid={`option_${opt.identifier}`}
                                            type="radio"
                                            id={opt.identifier}
                                            disabled={
                                              showAnswerFlag == true
                                                ? true
                                                : false
                                            }
                                            className="ppQuizOptionsBtn mr-1"
                                            name="quizOptions"
                                            checked={
                                              showAnswerFlag == true
                                                ? ques.SelectedAnswer === ""
                                                  ? opt.correct
                                                  : ques.SelectedAnswer ===
                                                    opt.identifier
                                                : ques.SelectedAnswer ===
                                                  opt.identifier
                                            }
                                            onChange={() => [
                                              (ques.SelectedAnswer =
                                                opt.identifier),
                                              handleSelOption(),
                                            ]}
                                          />
                                        </div>
                                        <label
                                          htmlFor={opt.identifier}
                                          className="d-flex d-flex-row"
                                        >
                                          <span className="ppQuizOptions mr-1">
                                            {opt.label}
                                          </span>
                                          <InnerHTML
                                            html={opt.answerText}
                                            className="ppQuizOptions"
                                          />
                                        </label>
                                      </div>
                                    </>
                                  );
                                },
                              )}
                            </div>
                            {/* Button Row */}
                            <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4 pr-0">
                              <div
                                className={
                                  ppQuizResultVO.isGraded === false ||
                                  ppQuizResultVO.isGraded === "false"
                                    ? showQuestionList
                                      ? "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4 text-xl-left text-lg-left text-md-left text-sm-left text-left pr-0"
                                      : "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4 text-xl-left text-lg-left text-md-left text-sm-left text-left pr-0"
                                    : showQuestionList
                                      ? "col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 mt-4 pr-0"
                                      : "col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mt-4"
                                }
                              >
                                <div
                                  className={
                                    ppQuizResultVO.isGraded === false ||
                                    ppQuizResultVO.isGraded === "false"
                                      ? "d-inline-flex ppQuizOtherBtnFullWidth"
                                      : ""
                                  }
                                >
                                  <button
                                    type="button"
                                    className={
                                      ppQuizResultVO.isGraded === false ||
                                      ppQuizResultVO.isGraded === "false"
                                        ? "btn ppQuizOtherBtn mr-xl-2 mr-lg-2 mr-md-2 mr-sm-2 mr-1 rounded-0 ppQuizOtherBtnWidth"
                                        : "btn ppQuizOtherBtn rounded-0 ppQuizOther3BtnWidth"
                                    }
                                    onClick={() => [
                                      (ques.SelectedAnswer = ""),
                                      handleSelOption(),
                                    ]}
                                    disabled={
                                      showAnswerFlag === true
                                        ? true
                                        : ques.SelectedAnswer === ""
                                          ? true
                                          : false
                                    }
                                  >
                                    Clear Response
                                  </button>
                                </div>
                                {ppQuizResultVO.isGraded === false ||
                                ppQuizResultVO.isGraded === "false" ? (
                                  <div
                                    className={
                                      showQuestionList
                                        ? "d-inline-flex ml-xl-4 ml-lg-4 ml-md-0 ml-sm-4 ml-2 mt-xl-0 mt-lg-0 mt-md-2 mt-sm-0 mt-0 ppQuizSABtnBtnBlockMargin"
                                        : "d-inline-flex ml-xl-4 ml-lg-4 ml-md-4 ml-sm-4 ml-2 ppQuizSABtnBtnBlockMargin"
                                    }
                                  >
                                    <button
                                      type="button"
                                      aria-pressed={showAnswerFlag}
                                      className={
                                        showQuestionList
                                          ? "btn ppQuizSABtn rounded-0 ppQuizSABtnWidth"
                                          : "btn ppQuizSABtn rounded-0"
                                      }
                                      onClick={() =>
                                        setShowAnswerFlag(!showAnswerFlag)
                                      }
                                    >
                                      {showAnswerFlag === false
                                        ? "Show Answer"
                                        : "Hide Answer"}
                                    </button>
                                  </div>
                                ) : null}
                              </div>
                              <div
                                className={
                                  ppQuizResultVO.isGraded === false ||
                                  ppQuizResultVO.isGraded === "false"
                                    ? showQuestionList
                                      ? "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 p-md-0 pl-xl-0 pl-lg-0 pl-md-0 pl-sm-0 pl-3 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                      : "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 p-md-0 pl-sm-0 pl-3 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                    : showQuestionList
                                      ? "col-xl-9 col-lg-8 col-md-8 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 pr-md-0 pl-xl-0 pl-lg-0 pl-md-0 pl-sm-0 pl-3 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                      : "col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 pr-md-0 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                }
                              >
                                <div className="d-inline-flex ppQuizOtherBtnBlockFullWidth">
                                  <button
                                    type="button"
                                    className={
                                      ppQuizResultVO.isGraded === false ||
                                      ppQuizResultVO.isGraded === "false"
                                        ? "btn ppQuizOtherBtn mr-xl-2 mr-lg-2 mr-md-0 mr-sm-2 mr-0 mb-xl-0 mb-lg-0 mb-md-2 mb-sm-0 mb-0 rounded-0"
                                        : "btn ppQuizOtherBtn mr-xl-2 mr-lg-2 mr-md-2 mr-sm-2 mr-0 rounded-0"
                                    }
                                    onClick={() => [
                                      setCurrQuest(currQuest - 1),
                                      handlePrevNxtBtn(),
                                    ]}
                                    disabled={currQuest === 1 ? true : false}
                                  >
                                    Previous Question
                                  </button>
                                </div>
                                <div className="d-inline-flex ml-xl-4 ml-lg-2 ml-md-4 ml-sm-4 ml-2 ppQuizOtherBtnBlockMargin">
                                  <button
                                    type="button"
                                    className={
                                      ppQuizResultVO.isGraded === false ||
                                      ppQuizResultVO.isGraded === "false"
                                        ? showQuestionList
                                          ? "btn ppQuizOtherBtn rounded-0 px-md-4"
                                          : "btn ppQuizOtherBtn rounded-0"
                                        : "btn ppQuizOtherBtn rounded-0 "
                                    }
                                    onClick={() => [
                                      setCurrQuest(currQuest + 1),
                                      handlePrevNxtBtn(),
                                    ]}
                                    disabled={
                                      currQuest === totalQuests ? true : false
                                    }
                                  >
                                    Next Question
                                  </button>
                                </div>
                              </div>
                            </div>
                            {/* Show Answer / Rationale */}
                            {showAnswerFlag == true ? (
                              <div className="col-12">
                                {ques.choiceInteraction.simpleChoices.map(
                                  (opt, optIndex) => {
                                    return opt.correct ? (
                                      <div
                                        key={optIndex}
                                        className="d-flex flex-row ppQuizCorrAnsTxt"
                                      >
                                        Correct Answer:{" "}
                                        {opt.label.replace(/[\])}[{(]/g, "")}
                                      </div>
                                    ) : opt.identifier ==
                                      ques.SelectedAnswer ? (
                                      <div
                                        key={optIndex}
                                        className="d-flex flex-row ppQuizWrnAnsTxt"
                                      >
                                        Your Answer:{" "}
                                        {opt.label.replace(/[\])}[{(]/g, "")}
                                      </div>
                                    ) : null;
                                  },
                                )}
                                <div>
                                  <p className="ppQuizOptions mr-1">
                                    {" "}
                                    Rationale:{" "}
                                  </p>
                                  <InnerHTML
                                    html={ques.rationale[0].feedbackText}
                                    className="ppQuizOptions"
                                  />
                                </div>
                              </div>
                            ) : null}
                            <div className="ppQuizQuestionID row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
                              ID: {ques.identifier}
                            </div>
                          </>
                        ) : null;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div
                    className="pb-2 mt-3"
                    style={{ textAlign: "center", fontFamily: "Fira Sans" }}
                  >
                    No Quiz Data Available
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal
        show={submitQuizPopUp}
        size="sm"
        aria-labelledby={SUBMIT_QUIZ_DIALOG_TITLE_ID}
        aria-describedby={SUBMIT_QUIZ_DIALOG_DESCRIPTION_ID}
        dialogAs={PracticePerfectModalDialog}
        dialogLabelledBy={SUBMIT_QUIZ_DIALOG_TITLE_ID}
        centered
        onHide={() => [setSubmitQuizPopUp(false), start()]}
      >
        <Modal.Header className="ppStudQuizPopUpHeader mt-4 mb-2 justify-content-center border-0">
          <Modal.Title
            as="h2"
            id={SUBMIT_QUIZ_DIALOG_TITLE_ID}
            className="sr-only"
          >
            {submitQuizDialogTitle}
          </Modal.Title>

          <div
            className="fa fa-exclamation-circle"
            aria-hidden="true"
            style={
              totalUnAnsQuests === 0
                ? { fontSize: "30px", color: "grey" }
                : { fontSize: "30px", color: "red" }
            }
          />
        </Modal.Header>

        <Modal.Body
          className="ppStudQuizPopUpBody mx-4"
          id={SUBMIT_QUIZ_DIALOG_DESCRIPTION_ID}
        >
          {totalUnAnsQuests === 0 ? null : (
            <p className="ppStudQuizPopUpTxt" style={{ color: "red" }}>
              You have {totalUnAnsQuests}{" "}
              {totalUnAnsQuests > 1 ? "questions" : "question"} unanswered.
            </p>
          )}

          <p className="ppStudQuizPopUpTxt">
            Are you sure you want to submit this quiz?
          </p>
        </Modal.Body>

        <Modal.Footer className="ppStudQuizPopUpFooter border-0 justify-content-center">
          <button
            type="button"
            className="ppStudQuizPopUpBtns mr-2 "
            onClick={() => [setSubmitQuizPopUp(false), start()]}
          >
            No, Go Back
          </button>

          <button
            type="button"
            className="ppStudQuizPopUpBtns"
            onClick={handleSubmitQuiz}
          >
            Yes, Submit
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        className="modal fade PPProfWelcomePopup"
        contentClassName="p-4"
        show={isShowStdQuizResetPopup}
        onHide={() => [setSubmitQuizPopUp(false), start()]}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
        dialogAs={PracticePerfectModalDialog}
      >
        <div className="ppProfQuizResetPopUp">
          <Modal.Header>
            <Modal.Title
              className="ProfWelcomePopupTitle"
              id="quiz-updated-dialog-title"
            >
              Your quizzes have been updated
            </Modal.Title>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={ppQuizResetPopupFocus}
              onClick={() => [
                setShowStdQuizResetPopup(false),
                handleRedirectHome(),
              ]}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body className="p-0" id="quiz-updated-dialog-description">
            <p className="PPWelProfPopupTxt mb-2 pt-3">
              We regret to inform you that there was an editorial error in the
              following quizzes, which requires us to update the quizzes. The
              below-mentioned questions have been removed to maintain the
              highest quality content on our platform. Therefore, if you have
              already attempted any of the quizzes or are currently in the
              process of attempting them, we have updated your scores and
              progress on these quizzes. We apologize for the inconvenience this
              has caused and appreciate your understanding.
            </p>
            <br></br>
            <p>List of the questions that were deleted:</p>
            <ol className="pl-3">
              {Boolean(isResetNotificationData)
                ? isResetNotificationData.map((resetChapterData) => {
                    return (
                      <li>
                        <p>{resetChapterData.Message}</p>
                      </li>
                    );
                  })
                : null}
            </ol>
            <div className="PPProfWelChecboxDivBottom mt-5">
              <label style={{ marginTop: "5px" }}>
                <input
                  type="checkbox"
                  onChange={() => updatePPRestNotification(3)}
                  value=""
                />{" "}
                Do not show this message again
              </label>
              <button
                style={{ float: "right" }}
                className="btn btn-primary rounded-0 ppProfQuizUpdatedPopup px-3 py-1 ml-2"
                onClick={() => [
                  setShowStdQuizResetPopup(false),
                  handleRedirectHome(),
                ]}
              >
                OK
              </button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
}
